import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'





// -----------------------------------------------------------------------------
// 2. Global GSAP Setup & Reflow Prevention
// -----------------------------------------------------------------------------
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Prevent forced reflows on mobile address bar resizes & batch callbacks
ScrollTrigger.config({ 
  ignoreMobileResize: true, 
  limitCallbacks: true 
});

// ✅ FIX: Force GSAP ScrollTrigger to recalculate exact height measurements 
// ONLY AFTER custom web fonts are fully loaded to avoid layout-shift reflows
if (typeof document !== 'undefined' && 'fonts' in document) {
  document.fonts.ready.then(() => {
    ScrollTrigger.refresh();
  });
}

// -----------------------------------------------------------------------------
// 3. React Application Mount
// -----------------------------------------------------------------------------
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)